import { Text, Card, Flex, Heading, Button } from '@radix-ui/themes'
import { Link } from '@tanstack/react-router'
import { DateTime } from 'luxon'
import { EiffageScan } from '@willie/schemas'
import SecuredOrgImage from '~/components/SecuredOrgImage'
import StatusBadge from './StatusBadge'
import cn from 'classnames'
import { useTRPC } from '~/utils/trpc'
import { MouseEventHandler } from 'react'
import { toast } from 'sonner'
import { LuRefreshCw } from 'react-icons/lu'
import { useMutation } from '@tanstack/react-query'
import { usrIsMobileScreenSize } from '~/hooks/usrIsMobileScreenSize'

interface ScanListItemProps {
  scan: EiffageScan
  className?: string
}

export const ScanSummary = ({ scan, className }: ScanListItemProps) => {
  const isMobile = usrIsMobileScreenSize()
  const trpc = useTRPC()

  const { mutate, isPending } = useMutation({
    ...trpc.plugins.scansRouter.processScan.mutationOptions()
  })

  const handleRetryScanClick: MouseEventHandler = (e) => {
    e.preventDefault()
    e.stopPropagation()
    mutate({ scanID: scan.ID })
    toast.info('Réessaie du traittement du carnet lancée')
  }

  return (
    <Card className={cn('group', className)}>
      <Flex align="center" p="2" gap={'3'}>
        <SecuredOrgImage fileName={`scans/${scan.ID}`} zoomable imgProps={{ width: 50 }} />
        <Flex direction={'column'} gap={'1'}>
          <Heading size="3" className="line-clamp-2">
            {scan.name}
          </Heading>
          <Text size="2" color="gray">
            {DateTime.fromISO(scan.createdAt).toLocaleString(DateTime.DATE_MED, { locale: 'fr-FR' })}
          </Text>
        </Flex>
        <Flex ml="auto" align={'center'} gap="4">
          {scan.status === 'failed' && (
            <Button
              size={isMobile ? '3' : '2'}
              variant="ghost"
              color="blue"
              onClick={handleRetryScanClick}
              className={cn('sm:hidden group-hover:flex items-center', {
                '!hidden': isPending
              })}
            >
              <LuRefreshCw size={isMobile ? 22 : 14} />
              <span className="hidden sm:inline">Réessayer</span>
            </Button>
          )}
          <StatusBadge scanStatus={isPending ? 'processing' : scan.status} />
        </Flex>
      </Flex>
    </Card>
  )
}

export const NavigatableScanSummary = ({ scan: scan }: ScanListItemProps) => {
  return (
    <Link key={scan.ID} to={'/plugins/eiffage-scans/$scanID'} params={{ scanID: `${scan.ID}` }}>
      <ScanSummary scan={scan} className="cursor-pointer hover:bg-gray-50 hover:shadow-md " />
    </Link>
  )
}

export default NavigatableScanSummary
